import { useCallback, useContext } from "react";
import { OverlayTriggerStateContext } from "react-aria-components";

import Button from "../Button";
import { useIsDismissable } from "./useIsDismissable";

type ModalCancelButtonProps = {
  onClick?: () => void;
};

const ModalCancelButton = ({ onClick }: ModalCancelButtonProps) => {
  const state = useContext(OverlayTriggerStateContext);
  const isDismissable = useIsDismissable();

  const handleClose = useCallback(() => {
    onClick?.();
    state?.close();
  }, [onClick, state]);

  return (
    <Button variant="secondary" onPress={handleClose} disabled={!isDismissable}>
      Cancel
    </Button>
  );
};

ModalCancelButton.displayName = "DS.Modal.CancelButton";

export default ModalCancelButton;
